import { Theme } from '@mui/material/styles/createTheme';

import { makeStyles } from 'tss-react/mui';

import palette from '../../../../styles/palette';

const useStyles = makeStyles<Theme>()((theme) => ({
  addActionButton: {
    border: `1px solid ${theme.palette.primary.main}`,
    '&:disabled': {
      borderColor: palette.grey[200],
    },
  },
}));
export default useStyles;
